import React, { useState } from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { gtmTracking } from "@/utils/gtm-tracking"

const AccordionItem = ({ title, faqKey, children, isActive = "false" }) => {
  const { t } = useTranslation()
  const displayTitle = faqKey ? t(`${faqKey}.question`) : title

  const [active, setActive] = useState(isActive === "true")

  return (
    <div className="accordion-item col-xs-12">
      <button
        type="button"
        aria-label={
          active
            ? t("common.read-more-about", { title: displayTitle })
            : t("common.read-less-about", { title: displayTitle })
        }
        onClick={() => {
          const newActive = !active
          gtmTracking("FAQ Click", newActive ? "Open" : "Close", displayTitle)()
          setActive(newActive)
        }}
        className="accordion-item__button"
        aria-controls="accordion-content"
        aria-expanded={active}
      >
        <h3
          className={`mb-0 text-left accordion-item__title ${
            active ? "accordion-item__title--border" : ""
          }`}
        >
          <span className="mb-0">{displayTitle}</span>
          {!active ? (
            <img
              className="accordion-list__icon-open"
              src="/icons/open-accordion.svg"
              alt=""
              role="presentation"
            />
          ) : (
            <img
              className="accordion-list__icon-close"
              src="/icons/close-accordion.svg"
              alt=""
              role="presentation"
            />
          )}
        </h3>
      </button>
      <div
        id="accordion-content"
        className="accordion-item__body"
        hidden={!active}
      >
        {children}
      </div>
    </div>
  )
}

export default AccordionItem
